import {useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {handleError} from "../../lib/errorHandler.js";
import {axios} from "../../lib/axios.js";
export const useProductShopeeCounts = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (search) => {
    setLoading(true);
    let params = {
      channelId: search?.channelId || "SHOPEE_ID",
      keyword: search?.keyword,
      keywordType: search?.keywordType,
      mpType: search?.mpType,
      type: search?.type,
      stockStatus: search?.stockStatus,
      categories: search?.categories,
      shopIds: search?.shopIds,
      countryCode: search?.countryCode,
      updateDates: search?.updateDates,
      hasChildrenCategory: search?.hasChildrenCategory || false
    };
    try {
      const {data: content} = await axios.post(`/saas/product/v1/products/status/count`, params);
      setData(content);
      return {
        productShopeeCounts: content
      };
    } catch (error) {
      handleError(error);
      return {
        productShopeeCounts: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productShopeeCountsLoading: loading,
    productShopeeCounts: data,
    fetchProductShopeeCounts: fetchData
  };
};
export const useProductShopeeCountsModel = createModel(useProductShopeeCounts);
